import { takeLatest, call, put } from 'redux-saga/effects';

import {
  GET_PRODUCT_CHECKOUT_PAGE_START,
  GET_PRODUCT_CHECKOUT_PAGE_SUCCESS,
  GET_PRODUCT_CHECKOUT_PAGE_ERROR,
} from '../actions/productCheckoutPage';
import api from '../api';

function createGetProductCheckoutPage() {
  return function* (option) {
    const { testCode, language } = option.payload;
    try {
      const data = yield call(() =>
        api.getProductCheckoutPage(testCode, language),
      );
      const action = { type: GET_PRODUCT_CHECKOUT_PAGE_SUCCESS, data };

      yield put(action);
    } catch (error) {
      const action = { type: GET_PRODUCT_CHECKOUT_PAGE_ERROR, error };

      yield put(action);
    }
  };
}

function* getProductCheckoutPageWatcher() {
  yield takeLatest(
    GET_PRODUCT_CHECKOUT_PAGE_START,
    createGetProductCheckoutPage(),
  );
}

const productCheckoutPageSagas = [getProductCheckoutPageWatcher()];

export default productCheckoutPageSagas;
